import { useEffect } from 'react';
import { debounce } from 'lodash';

export const useViewportSize = (debounceInterval) => {
    useEffect(() => {
        function updateSize() {
            if (document.documentElement?.style?.setProperty) {
                document.documentElement.style.setProperty('--win-height', `${window.innerHeight}px`);
                document.documentElement.style.setProperty('--win-width', `${window.innerWidth}px`);
            }
        }

        // handle debouncing?
        const handleResize = debounceInterval ? debounce(updateSize, debounceInterval) : updateSize;

        // call once to initialise
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [debounceInterval]);
};
